import { getDealerSiteRoutes } from './common'

export default getDealerSiteRoutes('/')
